import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { LibSspcommonService } from 'lib-sspcommon';
import { ViewManagementService } from './view-management.service';
import { AdminAuthService } from 'auth-n';
import { AuthRet } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SSPCommonruntimeService {

  constructor(
    private authservice: AuthService,
    private libsspcommon: LibSspcommonService,
    private viewManagementService: ViewManagementService,
    private authn: AdminAuthService,
  ) {
    this.authn.loginSuccess.subscribe({
      next: (authResult) => {
        if (authResult) {
          this.updateUserDetails();
        }
      }
    });

    this.authservice.baDetailsAvailable.subscribe({
      next: (authRet: AuthRet) => {
        if (authRet && this.authservice.isEsignage) {
          this.updateUserDetails();
        }
      }
    });
  }

  public updateUserDetails() {
    this.libsspcommon.setAdminLog(this.viewManagementService.componentStates.AdminLog);
    this.libsspcommon.accessToken.next(this.authservice.accessToken);
    this.libsspcommon.setBrowserLanguage(this.authservice.getBrowserLanguage());
    this.libsspcommon.setLoggedInUserEmail(this.authservice.userEmail);
    this.libsspcommon.setLoggedInUserName(this.authservice.UserName);
    this.libsspcommon.setConnectionName(this.authservice.getConnectionName);
    this.libsspcommon.setApplicationType(this.authservice.applicationType);
    this.libsspcommon.setEsignageAdminRole(this.authservice.esgAdminRole);
    this.libsspcommon.setEsignageUserType(this.authservice.esgUserType);
    this.libsspcommon.setRmmAdminRole(this.authservice.rmmAdminRole);
    this.libsspcommon.setMettingRole(this.authservice.adminRole);
    this.libsspcommon.setScpAdminRole(this.authservice.cpUserRole);
    this.libsspcommon.setTenantInfo(this.authservice.tenantInfo);
    this.libsspcommon.setTenantTier(this.authservice.tenantTier);
    this.libsspcommon.setTier(this.authservice.tier);
    this.libsspcommon.setViewRmm(this.authservice.viewRmm);
    this.libsspcommon.setViewSignage(this.authservice.viewSignage);
    this.libsspcommon.setViewGo(this.authservice.viewGo);
    this.libsspcommon.setViewMeeting(this.authservice.viewMeeting);
    this.libsspcommon.setViewScp(this.authservice.viewScp);
  }
}
